import { render, staticRenderFns } from "./EmiDetails.vue?vue&type=template&id=1e481d13&scoped=true"
import script from "./EmiDetails.vue?vue&type=script&lang=js"
export * from "./EmiDetails.vue?vue&type=script&lang=js"
import style0 from "./EmiDetails.vue?vue&type=style&index=0&id=1e481d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e481d13",
  null
  
)

export default component.exports